import { render, staticRenderFns } from "./BalanceCard.vue?vue&type=template&id=4c4e4252&scoped=true&"
import script from "./BalanceCard.vue?vue&type=script&lang=js&"
export * from "./BalanceCard.vue?vue&type=script&lang=js&"
import style0 from "./BalanceCard.vue?vue&type=style&index=0&id=4c4e4252&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4e4252",
  null
  
)

export default component.exports